import React from "react";
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress
} from "@mui/material";
import { getCourtData, courtServeRequest } from "../../redux/actions/court.action";

interface CaseItem {
  caseId: string;
  caseName: string;
  caseNumber: string;
  filedDate: string;
  court: {
    system: string;
    name: string;
    courtId: string;
  };
  matchedObjectArray?: {
    matchedObjectName: string;
    matchedObjectAttribute: string;
    highlightSnippet: string;
  }[];
}

interface Props {
  caseList: CaseItem[];
  isLoading: boolean;
}

const CaseResultTable = (props: Props) => {
  const navigate = useNavigate();
  const dispatch: Dispatch = useDispatch();
  const { caseList, isLoading } = props;  
  const GoToEditOrder = (caseItem: any) => {
    if(caseItem?.court?.courtId){
      dispatch(getCourtData(caseItem?.court.courtId))
        .then((response: any) => {
          if (response && response.success && response.data[0].active === true) {
            navigate("/order/save", { state: { case: caseItem } });
          } else {
            toast.error("We cannot serve this court at this point. However, we are expanding the courts we can serve every day.");
            dispatch(courtServeRequest(caseItem?.court));
          }
        })
        .catch((error: Error) => {
          console.error(error);
        });
    }else{
      toast.error("This case is not associated with a court. Please check the details or try selecting a different case.");
    }
  };
  return (
    isLoading == true ? (
      <div className="flex justify-center w-full px-12 py-32">
        <LinearProgress className="w-96" />
      </div>
    ) : (
      <Box p={3} >
        <Typography variant="h6" gutterBottom>
          Search Results
        </Typography>

        <TableContainer component={Paper}>
          <Table size="small" aria-label="case results table">
            <TableHead>
              <TableRow>
                <TableCell>Case Name</TableCell>
                <TableCell>Case Number</TableCell>
                <TableCell>Filed Date</TableCell>
                <TableCell>Court System</TableCell>
                <TableCell>Court Name</TableCell>
                {/* <TableCell>Matched Object Name</TableCell> */}
                {/* <TableCell>Matched Object Attribute</TableCell> */}
                {/* <TableCell>Highlight Snippet</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {caseList.length > 0 && caseList.map((caseItem, index) => {
                // const matched = (caseItem.matchedObjectArray?.[0] ?? {}) as {
                //   matchedObjectName?: string;
                //   matchedObjectAttribute?: string;
                //   highlightSnippet?: string;
                // };
                return (
                  <TableRow key={caseItem.caseId || index} className="cursor-pointer hover:bg-gray-900" onClick={() => GoToEditOrder(caseItem)}>
                    <TableCell>{caseItem.caseName}</TableCell>
                    <TableCell>{caseItem.caseNumber}</TableCell>
                    <TableCell>{new Date(caseItem.filedDate).toLocaleDateString()}</TableCell>
                    <TableCell>{caseItem.court?.system}</TableCell>
                    <TableCell>{caseItem.court?.name}</TableCell>
                    {/* <TableCell>{matched.matchedObjectName || "-"}</TableCell> */}
                    {/* <TableCell>{matched.matchedObjectAttribute || "-"}</TableCell> */}
                    {/* <TableCell>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            matched.highlightSnippet?.replace(
                              /<b>(.*?)<\/b>/g,
                              "<b style=\"color:red;\">$1</b>"
                            ) || "-"
                        }}
                      />
                    </TableCell> */}
                  </TableRow>
                );
              })}
              {
                caseList.length == 0 && (
                  <TableRow>
                    <TableCell colSpan={8} className="text-center">No results found</TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box >
    )
  );
};

export default CaseResultTable;
